/* AuraReiment shared color resolver for product, card, and filter swatches. */
(() => {
  if (window.__auraSwatchColors) return;
  window.__auraSwatchColors = true;

  const palette = {
    beige: '#d8c9ad',
    black: '#111111',
    'black melange': '#303033',
    'bottle green': '#164b3b',
    'brick red': '#a4473d',
    'charcoal melange': '#4c4f52',
    'coffee brown': '#6f4e37',
    copper: '#b87333',
    coral: '#ef7768',
    'flag green': '#138808',
    'golden yellow': '#e5ad22',
    'grey melange': '#aaa9a6',
    jade: '#2f8f73',
    lavender: '#bca7d8',
    'light baby pink': '#efc0ca',
    maroon: '#842b38',
    mint: '#a8dbc5',
    'mustard yellow': '#d49a20',
    'navy blue': '#182b4d',
    'navy melange': '#35445f',
    'new yellow': '#f3d447',
    'off white': '#eee9dc',
    'olive green': '#667344',
    orange: '#e87527',
    'petrol blue': '#227786',
    pink: '#e99bad',
    purple: '#704496',
    'purple melange': '#80658f',
    red: '#c92d38',
    'royal blue': '#2864c7',
    'steel grey': '#737b83',
    white: '#f7f7f4',
    yellow: '#f2cc28',
  };

  const normalize = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ');

  const generatedColor = (name) => {
    let hash = 0;
    for (const character of name) hash = (hash * 31 + character.charCodeAt(0)) | 0;
    return `hsl(${Math.abs(hash) % 360} 55% 42%)`;
  };

  const resolveColor = (value) => {
    const name = normalize(value);
    if (!name) return '';
    if (palette[name]) return palette[name];
    if (!name.includes(' ') && CSS.supports('color', name)) return name;
    return generatedColor(name);
  };

  const apply = (root = document) => {
    root.querySelectorAll?.('[data-aura-swatch-name]').forEach((element) => {
      const color = resolveColor(element.dataset.auraSwatchName);
      if (!color) return;

      if (element.tagName === 'OPTION') {
        if (!element.dataset.optionSwatchValue) element.dataset.optionSwatchValue = color;
        return;
      }

      if (element.dataset.auraNativeSwatch !== 'true') {
        element.style.setProperty('--aura-swatch-color', color);
        element.style.setProperty('--swatch--background', color);
      }
      element.classList.remove('swatch--unavailable');
    });
  };

  const observer = new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) apply(node);
    }));
  });

  const start = () => {
    apply();
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.addEventListener('shopify:section:load', (event) => apply(event.target));
})();
